import {
  FilterDocument,
  GroupByMode,
  TodayGroupBy,
  UserSettings,
} from '@griply/types';

const TODAY_GROUP_BY_VALUES = new Set<string>(Object.values(TodayGroupBy));

const toTodayGroupBy = (
  groupByMode: FilterDocument['groupByMode'],
): TodayGroupBy | null => {
  if (!groupByMode) {
    return null;
  }
  if (groupByMode === GroupByMode.Deadline) {
    return TodayGroupBy.None;
  }
  return TODAY_GROUP_BY_VALUES.has(groupByMode)
    ? (groupByMode as unknown as TodayGroupBy)
    : null;
};

export const mapPartialToTodaySettings = (
  partial: Partial<FilterDocument>,
): Partial<UserSettings> | null => {
  const settings: Partial<UserSettings> = {};
  const todaySlot: Partial<FilterDocument> = {};

  if (partial.sortingMode !== undefined) {
    settings.todoSortingMode = partial.sortingMode ?? undefined;
  }

  if (partial.groupByMode !== undefined) {
    settings.todayGroupBy = toTodayGroupBy(partial.groupByMode) ?? undefined;
  }

  if (partial.collapsedSections !== undefined) {
    todaySlot.collapsedSections = partial.collapsedSections;
  }

  if (partial.filters !== undefined) {
    const tagFilter = partial.filters?.tag;

    if (tagFilter === null || tagFilter === undefined) {
      settings.todayFilterByTags = [];
      todaySlot.filters = { tag: null };
    }

    if (tagFilter) {
      settings.todayFilterByTags = tagFilter.include ?? [];
      const noTag = tagFilter.noTag ? true : null;
      const matchMode = tagFilter.matchMode ?? null;
      todaySlot.filters = {
        tag: noTag || matchMode ? { noTag, matchMode } : null,
      };
    }
  }

  if (Object.keys(todaySlot).length) {
    settings.filters = { today: todaySlot };
  }

  if (!Object.keys(settings).length) {
    return null;
  }

  return settings;
};
